import classNames from "classnames";
import { useState } from "react";

import NoResultsIcon from "assets/img/no-results-icon.svg";
import styles from "./style.module.scss";

export const NoMatchFoundCard = ({
  onActionClick,
  isInventory,
  buttonText = "Clear Filters",
  text = "Please check your search query for spelling errors or expand the search/filtering criteria and try again.",
  hideButton = false,
}: NoMatchFoundCardProps) => {
  const [loaded, setLoaded] = useState(false);

  const noResultsBoxClassnames = classNames(styles.noResultsBox, {
    [styles.noResultsInInventory]: isInventory,
  });

  return (
    <div className={noResultsBoxClassnames} data-testid="no-result-found-card">
      <div className={styles.iconContainer}>
        <img
          src={NoResultsIcon}
          style={!loaded ? { display: "none" } : undefined}
          alt="no results icon"
          onLoad={() => setLoaded(true)}
        />
      </div>

      <div className={styles.textContainer}>
        <div className={styles.title}>No results found</div>
        <span className={styles.description}>{text}</span>
        {!hideButton && (
          <div className={styles.clearFiltersButton} onClick={onActionClick}>
            {buttonText}
          </div>
        )}
      </div>
    </div>
  );
};

export interface NoMatchFoundCardProps {
  onActionClick: () => void;
  isInventory?: boolean;
  buttonText?: string;
  text?: string;
  hideButton?: boolean;
}

export const NoMatchFoundPlaceholder = ({
  onActionClick,
}: NoMatchFoundCardProps) => {
  return (
    <div className={styles.noMatchPlaceholderContainer}>
      <div className={styles.title}>No results found</div>
      <span className={styles.description}>
        Please select a different image
      </span>
      <div className={styles.clearFiltersButton} onClick={onActionClick}>
        Clear Filters
      </div>
    </div>
  );
};
